import localStorageService from '@/utils/local-storage-service'
import * as types from '../mutation-types'

const localStorageKey = 'continueCreate'

const state = {
  get data () {
    let data = localStorageService.getItem(localStorageKey)
    return data
  },
  set data (v) {
    localStorageService.setItem(localStorageKey, v)
  }
}

const actions = {
  SetContinueCreate ({ commit }, data) {
    commit(types.ContinueCreateSet, data)
  },
  ClearContinueCreate ({commit}) {
    commit(types.ContinueCreateClear)
  }
}

const mutations = {
  [types.ContinueCreateSet] (state, data) {
    let oldData = state.data
    state.data = data != null ? data : oldData.data
  },
  [types.ContinueCreateClear] (state) {
    localStorageService.removeItem(localStorageKey)
    state.data = { ...state.data }
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/continue-create.js